import {
	HttpClient,
	HttpEvent,
	HttpHeaders,
	HttpResponse,
} from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { AbstractHttpService } from './http-abstract.service';
import {
	DynamicEntityDto,
	DynamicPropertyDto,
	DynamicTemplateDto,
	WorkflowDto,
} from './dto';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
	providedIn: 'root',
})
export class HttpWorkflowService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/workflow', authService);
	}
	public getAll(): Observable<WorkflowDto[]> {
		return super.doGet(true, '/');
	}
	public newWorkflow(): Observable<WorkflowDto> {
		return super.doGet(true, `/new`);
	}
	public getForProduct(
		productType: string,
		productId?: number,
	): Observable<WorkflowDto> {
		if (!productId) {
			return super.doGet(true, `/product/${productType}`);
		} else {
			return super.doGet(true, `/product/${productType}/${productId}`);
		}
	}
	public get(id: number): Observable<WorkflowDto> {
		return super.doGet(true, `/${id}`);
	}
	public edit(id: number, payload: WorkflowDto): Observable<WorkflowDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public editForProduct(
		id: number,
		productId: number,
		payload: WorkflowDto,
	): Observable<WorkflowDto> {
		return super.doPost(true, `/${id}/product:${productId}`, payload);
	}
	public save(payload: WorkflowDto | FormGroup): Observable<WorkflowDto> {
		return super.doPost(true, `/`, payload);
	}
	getEmailPlaceholders(
		payload: WorkflowDto,
	): Observable<{ [key: string]: string }>;
	getEmailPlaceholders(
		id: number,
		payload: WorkflowDto,
	): Observable<{ [key: string]: string }>;
	getEmailPlaceholders(
		idOrPayload: number | WorkflowDto,
		payload?: WorkflowDto,
	): Observable<{ [key: string]: string }> {
		if (typeof idOrPayload === 'number') {
			return super.doPost(
				true,
				`/${idOrPayload}/emailPlaceholders`,
				payload!,
			);
		}

		return super.doPost(true, `/emailPlaceholders`, idOrPayload);
	}

	getEmailPlaceholdersForWorkflow(
		id: number,
		payload: WorkflowDto,
	): Observable<{ [key: string]: string }> {
		return this.getEmailPlaceholders(id, payload);
	}
}
